/**
 * Simple event emitter for trade events
 * Allows components to listen for trade completion and refresh their data
 */

class TradeEventEmitter {
  constructor() {
    this.listeners = new Set();
  }

  /**
   * Subscribe to trade completion events
   * @param {Function} callback - Function to call when a trade completes
   * @returns {Function} Unsubscribe function
   */
  subscribe(callback) {
    this.listeners.add(callback);
    console.log('📢 Subscriber added to trade events. Total listeners:', this.listeners.size);
    
    // Return unsubscribe function
    return () => {
      this.listeners.delete(callback);
      console.log('📢 Subscriber removed from trade events. Total listeners:', this.listeners.size);
    };
  }

  /**
   * Notify all subscribers that a trade has completed
   * @param {Object} tradeData - Information about the completed trade
   */
  emit(tradeData) {
    console.log('📢 Trade completed event emitted:', tradeData);
    console.log('📢 Notifying', this.listeners.size, 'listeners');
    
    this.listeners.forEach(callback => {
      try {
        callback(tradeData);
      } catch (error) {
        console.error('Error in trade event listener:', error);
      }
    });
  }
}

// Create singleton instance
export const tradeEvents = new TradeEventEmitter();

